// src/store/reducers/vehicleReducer.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import domain from '../../constants/config.js';

const apiUrl = domain.API_BASE_URL+'v1/user-details';

export const fetchClaimUserDetails = createAsyncThunk(
  'claim/fetchClaimUserDetails',
  async (id) => {
    try {
        console.log("datafetchMyPlans",id);
        console.log("apiUrl+'/'+idapiUrl+'/'+id",apiUrl+'/'+id);
      const response = await axios.get(apiUrl+'/'+id);
      return response.data;
    } catch (error) {
      return error.response?.data || error.message;
    }
  }
);

export const raiseClaim = createAsyncThunk(
    'claim/raiseClaim',
    async (data) => {
      try {
        const apiUrl = domain.API_BASE_URL+'v1/raise-claim';
          console.log("raiseClaim",data);
        const response = await axios.post(apiUrl,data);
        return response.data;
      } catch (error) {
        return error.response?.data || error.message;
      }
    }
  );

  export const trackClaim = createAsyncThunk(
    'claim/trackClaim',
    async (data) => {
      try {
        const apiUrl = domain.API_BASE_URL+'v1/track-claim';
          console.log("raiseClaim",data);
        const response = await axios.post(apiUrl,data);
        return response.data;
      } catch (error) {
        return error.response?.data || error.message;
      }
    }
  );

const claimListSlice = createSlice({
  name: 'claimList',
  initialState: {
    data:[],
    response: [],
    loading: false,
    claimRaiseloading:false,
    trackClaimloading:false,
    error: null,
    navigationData: {} ,
  },
  reducers: {
    setNavigationData: (state, action) => {
      state.navigationData = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClaimUserDetails.pending, (state) => {
        state.loading = true;
        console.log("fetchClaimUserDetails",state.loading);
      })
      .addCase(fetchClaimUserDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.response = action.payload;

      })
      .addCase(fetchClaimUserDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(raiseClaim.pending, (state) => {
        state.claimRaiseloading = true;
        console.log("raiseClaim",state.loading);
      })
      .addCase(raiseClaim.fulfilled, (state, action) => {
        state.claimRaiseloading = false;
        state.response = action.payload;

      })
      .addCase(raiseClaim.rejected, (state, action) => {
        state.claimRaiseloading = false;
        state.error = action.error.message;
      })

      .addCase(trackClaim.pending, (state) => {
        state.trackClaimloading = true;
        console.log("raiseClaim",state.loading);
      })
      .addCase(trackClaim.fulfilled, (state, action) => {
        state.trackClaimloading = false;
        state.response = action.payload;

      })
      .addCase(trackClaim.rejected, (state, action) => {
        state.trackClaimloading = false;
        state.error = action.error.message;
      });
  },
});

export const { setNavigationData } = claimListSlice.actions;
export default claimListSlice.reducer;